module.exports=/[\0-\x1F\x7F-\x9F]/


/*****************
 ** WEBPACK FOOTER
 ** ./~/uc.micro/categories/Cc/regex.js
 ** module id = ./node_modules/uc.micro/categories/Cc/regex.js
 ** module chunks = 1
 **/